<template>
  <div>
    <material-card color="#ed2224" title="Other Stats" offset="0">
      <v-layout justify-center wrap v-if="typeof stats != 'undefined'">
        <v-flex class="mt-2" xs6 lg4 xl3 style="text-align: center">
          <v-sheet
            elevation="1"
            class="mx-auto"
            color="#4cc7e8"
            height="100%"
            width="100%"
            justify-center
          >
            <v-layout class="pa-2" justify-center wrap>
              <v-flex xs12>
                <p
                  style="
                    color: white;
                    font-weight: bold;
                    font-size: 15pt !important;
                  "
                  class="mb-0"
                >
                  {{ stats.enquiriesCount }}
                </p>
                <p style="color: white">Enquiries & Repeat Sales</p>
              </v-flex>
            </v-layout>
            <!--  -->
          </v-sheet>
        </v-flex>
        <v-flex class="mt-2" xs6 lg4 xl3 style="text-align: center">
          <v-sheet
            elevation="1"
            class="mx-auto"
            color="#4cc7e8"
            height="100%"
            width="100%"
          >
            <v-layout class="pa-2" justify-center wrap>
              <v-flex xs12>
                <p
                  style="
                    color: white;
                    font-weight: bold;
                    font-size: 15pt !important;
                  "
                  class="mb-0"
                >
                  {{ formatMoney(stats.revenue) }}
                </p>
                <p style="color: white">Total REV in {{ stats.year }} (excl)</p>
              </v-flex>
            </v-layout>
          </v-sheet>
        </v-flex>
        <v-flex class="mt-2" xs6 lg4 xl3 style="text-align: center">
          <v-sheet
            elevation="1"
            class="mx-auto"
            color="#4cc7e8"
            height="100%"
            width="100%"
          >
            <v-layout class="pa-2" justify-center wrap>
              <v-flex xs12>
                <p
                  style="
                    color: white;
                    font-weight: bold;
                    font-size: 15pt !important;
                  "
                  class="mb-0"
                >
                  {{ formatMoney(stats.cC) }}
                </p>
                <p style="color: white">Total UC (excl)</p>
              </v-flex>
            </v-layout>
          </v-sheet>
        </v-flex>
        <v-flex class="mt-2" xs6 lg12 xl3 style="text-align: center">
          <v-sheet
            elevation="1"
            class="mx-auto"
            color="#4cc7e8"
            height="100%"
            width="100%"
          >
            <v-layout class="pa-2" justify-center wrap>
              <v-flex xs12>
                <p
                  style="
                    color: white;
                    font-weight: bold;
                    font-size: 15pt !important;
                  "
                  class="mb-0"
                >
                  {{ calculatePercent(stats.cC, stats.revenue) }}
                  %
                </p>
                <p style="color: white">UC to Rev %</p>
              </v-flex>
            </v-layout>
          </v-sheet>
        </v-flex>

        <v-divider></v-divider>
        <v-flex xs12 class="py-1">
          <v-progress-linear
            background-color="#325181"
            color="#4cc7e8"
            height="20"
            class="ma-1"
            :value="
              calculatePercent(stats.consumerEnquiries, stats.enquiriesCount)
            "
          ></v-progress-linear>
          <p>
            <span>
              <div
                class="ml-1"
                style="
                  width: 10pt;
                  height: 10pt;
                  background: #4cc7e8;
                  display: inline-block;
                "
              ></div>
              Consumer: {{ stats.consumerEnquiries }} ({{
                calculatePercent(stats.consumerEnquiries, stats.enquiriesCount)
              }}%)
            </span>

            <span style="float: right">
              <div
                style="
                  width: 10pt;
                  height: 10pt;
                  background: #325181;
                  display: inline-block;
                "
              ></div>
              Business / Organs: {{ stats.businessEnquiries }} ({{
                calculatePercent(stats.businessEnquiries, stats.enquiriesCount)
              }}%)
            </span>
          </p>
        </v-flex>
        <v-flex xs12>
          <div class="ml-1 mr-0" style="width: 100%">
            <div
              v-bind:style="{
                width:
                  calculatePercent(
                    stats.saleFallenThroughEnquiries,
                    stats.enquiriesCount
                  ) + '%',
              }"
              class="ma-0"
              style="
                height: 20px;
                background-color: #58595b;
                display: inline-block;
                transition: width 0.5s;
              "
            ></div>
            <div
              v-bind:style="{
                width:
                  calculatePercent(
                    parseInt(stats.enquiryEnquiries) +
                      parseInt(stats.commsConfirmedEnquiries) +
                      parseInt(stats.salePendingEnquiries) +
                      parseInt(stats.saleConfirmedEnquiries),
                    stats.enquiriesCount
                  ) + '%',
              }"
              class="ma-0"
              style="
                height: 20px;
                background-color: #e6e7e8;
                display: inline-block;
                transition: width 0.5s;
              "
            ></div>
            <div
              v-bind:style="{
                width:
                  calculatePercent(
                    stats.saleCompletedEnquiries,
                    stats.enquiriesCount
                  ) -
                  0.2 +
                  '%',
              }"
              class="ma-0"
              style="
                height: 20px;
                background-color: #68c8b3;
                display: inline-block;
                transition: width 0.5s;
              "
            ></div>
          </div>
          <p style="text-align: center">
            <span style="float: left">
              <div
                class="ml-1"
                style="
                  width: 10pt;
                  height: 10pt;
                  background: #58595b;
                  display: inline-block;
                "
              ></div>
              Fallen Through: {{ stats.saleFallenThroughEnquiries }} ({{
                calculatePercent(
                  stats.saleFallenThroughEnquiries,
                  stats.enquiriesCount
                )
              }}%)
            </span>
            <span>
              <div
                style="
                  width: 10pt;
                  height: 10pt;
                  background: #e6e7e8;
                  display: inline-block;
                "
              ></div>
              Outstanding:
              {{
                parseInt(stats.enquiryEnquiries) +
                parseInt(stats.commsConfirmedEnquiries) +
                parseInt(stats.salePendingEnquiries) +
                parseInt(stats.saleConfirmedEnquiries)
              }}
              ({{
                calculatePercent(
                  parseInt(stats.enquiryEnquiries) +
                    parseInt(stats.commsConfirmedEnquiries) +
                    parseInt(stats.salePendingEnquiries) +
                    parseInt(stats.saleConfirmedEnquiries),
                  stats.enquiriesCount
                )
              }}%)
            </span>

            <span style="float: right">
              <div
                style="
                  width: 10pt;
                  height: 10pt;
                  background: #68c8b3;
                  display: inline-block;
                "
              ></div>
              Completed: {{ stats.saleCompletedEnquiries }} (
              {{
                calculatePercent(
                  stats.saleCompletedEnquiries,
                  stats.enquiriesCount
                )
              }}
              %)
            </span>
          </p>
        </v-flex>

        <v-flex xs12 class="py-1">
          <apexchart
            height="300px"
            :options="upstreamStatusChartOptions"
            :series="upstreamStatusSeries"
          ></apexchart>
        </v-flex>
        <v-flex xs12 class="py-1">
          <v-progress-linear
            background-color="#68c6b3"
            color="#58595b"
            height="20"
            class="ma-1"
            :value="
              calculatePercent(
                stats.saleFallenThroughEnquiries,
                stats.completedEnquiriesCount
              )
            "
          ></v-progress-linear>
          <p>
            <span>
              <div
                class="ml-1"
                style="
                  width: 10pt;
                  height: 10pt;
                  background: #58595b;
                  display: inline-block;
                "
              ></div>
              Unconverted:
              {{
                calculatePercent(
                  stats.saleFallenThroughEnquiries,
                  stats.completedEnquiriesCount
                )
              }}%
            </span>

            <span style="float: right">
              <div
                style="
                  width: 10pt;
                  height: 10pt;
                  background: #68c6b3;
                  display: inline-block;
                "
              ></div>
              Converted:
              {{
                calculatePercent(
                  stats.completedEnquiriesCount -
                    stats.saleFallenThroughEnquiries,
                  stats.completedEnquiriesCount
                )
              }}%
            </span>
          </p>
        </v-flex>
      </v-layout>
    </material-card>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import moment from "moment";

  export default {
    props: ["stats"],
    components: {},
    data: () => ({
      upstreamStatusSeries: [],
      upstreamStatusChartOptions: {
        chart: {
          type: "pie",
        },
        colors: [
          "#ed2224",
          "#ed2224",
          "#feb019",
          "#b276b2",
          "#68c6b3",
          "#58595b",
        ],
        labels: [
          "Enquiry",
          "Comms Confirmed",
          "Sale Pending",
          "Sale Confirmed",
          "Sale Completed",
          "Fallen Through",
        ],
      },
    }),
    computed: {
      ...mapGetters({}),
    },
    watch: {
      stats: function () {
        this.updateGraphs();
      },
    },
    mounted() {
      this.updateGraphs();
    },
    methods: {
      updateGraphs() {
        if (typeof this.stats != "undefined") {
          this.upstreamStatusSeries = [
            parseInt(this.stats.enquiryEnquiries),
            parseInt(this.stats.commsConfirmedEnquiries),
            parseInt(this.stats.salePendingEnquiries),
            parseInt(this.stats.saleConfirmedEnquiries),
            parseInt(this.stats.saleCompletedEnquiries),
            parseInt(this.stats.saleFallenThroughEnquiries),
          ];
        }
      },
      calculatePercent(amount, total) {
        if (amount == 0) {
          return 0;
        }
        return parseFloat((parseInt(amount) / parseInt(total)) * 100).toFixed(1);
      },
      formatMoney(amount) {
        let formatter = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 2,
        });
        return formatter.format(amount);
      },
    },
    filters: {
      moment: function (date) {
        return moment.utc(date).local().format("MMM Do YYYY, h:mm a");
      },
    },
  };
</script>

<style lang="css">
  #statsModule h4.title.font-weight-light.mb-2 {
    font-weight: bold !important;
  }
</style>